<template>
   <div>
      <atom-button
         type="submit"
         class="mt-3"
         fullWidth
         >
         {{ isLoading ? `${loadingLabel} ...` : label }}
         <loading-icon v-if="isLoading" spinning/>
      </atom-button>
   </div>
</template>

<script>
import AtomButton from '../../../atoms/Login/Button';
import LoadingIcon from '../../../atoms/Login/LoadingIcon';

export default {
   name: 'submit-btn',
   components: {
      AtomButton,
      LoadingIcon,
   },
   props: {
      label: {
         type: String,
         default: 'Submit'
      },
      isLoading: {
         type: Boolean,
         required: true,
      },
      loadingLabel: {
         type: String,
         default: 'Submitting'
      },
   }
}
</script>
